import React, { /* useEffect,  */useState } from 'react';

import Wrapper from "./LaskinX/Wrapper";
import Screen from "./LaskinX/Screen";
import ButtonBox from "./LaskinX/ButtonBox";
import Button from "./LaskinX/Button";

import './LaskinX/laskin.css';

const btnValues = [
    ["C", "+-", "%", "/"],
    [7, 8, 9, "X"],
    [4, 5, 6, "-"],
    [1, 2, 3, "+"],
    [0, ".", "="],
    ];
    
const toLocaleString = (num) => String(num);//.replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, "$1 ");

const removeSpaces = (num) => num.toString().replace(/\s/g, "");

export default function Laskin() {

  let [calc, setCalc] = useState({
    sign: "",
    num: 0,
    res: 0,
  });
  
  const [lastClickedEqual, setLastClickedEqual] = useState(false);
  const [lastNum, setLastNum] = useState(0);
  const [calculation, setCalculation] = useState('');

  //const [lastClickedSign, setLastClickedSign] = useState(false);

  const numClickHandler = (e) => {

    e.preventDefault();
    const value = e.target.innerHTML;

    if (removeSpaces(calc.num).length < 16) {
      
      setCalculation(calculation + value);

      setCalc({
        ...calc,
        num:
          calc.num === 0 && value === "0" 
            ? "0"
            : removeSpaces(calc.num) % 1 === 0 && !removeSpaces(calc.num).includes('.') 
            ? toLocaleString(Number(removeSpaces(calc.num + value)))
            : toLocaleString(calc.num + value),
        res: !calc.sign ? 0 : calc.res,
      });
    }
  };
  /* useEffect(() => {

    console.log("calculation:"+calculation)

  }, [calculation]);  */
 

  const comaClickHandler = (e) => {

    e.preventDefault();

    const value = e.target.innerHTML;

    setCalculation(calculation + value);

    setCalc({
      ...calc,
      num: !calc.num.toString().includes(".") ? calc.num + value : calc.num,
    });
  };

  const signClickHandler = (e) => {

    const value = e.target.innerHTML;
    
    setCalculation(`${calc.num ? calc.num : calc.res}${e.target.innerHTML}`); 
    
    const myRes = (!calc.res && calc.num) ? calc.num : calc.res;
    
    setCalc({
      ...calc,
      sign: e.target.innerHTML,
      res: myRes,
      num: 0,
    });

    if (
      calculation.charAt(calculation.length-1) !== 'X' && 
      calculation.charAt(calculation.length-1) !== '/' &&
      calculation.charAt(calculation.length-1) !== '=' &&
      calculation.charAt(calculation.length-1) !== '+' &&
      calculation.charAt(calculation.length-1) !== '-'
      ) {
      calculate(value, false);
    } 
    else {
      setLastClickedEqual(false);
    }
  };

  const equalsClickHandler = () => {

    if (!lastClickedEqual) {
      setLastNum(calc.num);
      setCalculation(calculation + "=");
    } else {
      setCalculation(`${calc.num ? calc.num : calc.res}` + calc.sign + lastNum + "=");
    }
    calculate(calc.sign, true);
  };

  const calculate = (signIn, equalClicked) => {

    if (equalClicked) setLastClickedEqual(true);
    else setLastClickedEqual(false);

    if (calc.sign/*  && calc.num */) {

      const math = (a, b, sign) => 
        sign === "+"
          ? a + b
          : sign === "-"
          ? a - b
          : sign === "X"
          ? a * b
          : a / b;

      if (lastClickedEqual === true && equalClicked === true) {
        setCalc({
          ...calc,
          res:
            calc.num === "0" && calc.sign === "/"
              ? "Nollalla ei voi jakaa"
              : toLocaleString(
                  math(
                    Number(removeSpaces(calc.res)),
                    Number(removeSpaces(lastNum)),
                    calc.sign
                  )
                ),
          sign: signIn,
          num: 0
        });

      } else {
        setCalc({
          ...calc,
          res:
            calc.num === "0" && calc.sign === "/"
              ? "Nollalla ei voi jakaa"
              : toLocaleString(
                  math(
                    Number(removeSpaces(calc.res)),
                    Number(removeSpaces(calc.num)),
                    calc.sign
                  )
                ),
          sign: signIn,
          num: 0
        });
      }
    }
  }

  const invertClickHandler = () => {

    setCalc({
      ...calc,
      num: calc.num ? toLocaleString(removeSpaces(calc.num) * -1) : 0,
      res: calc.res ? toLocaleString(removeSpaces(calc.res) * -1) : 0,
      sign: "",
    });
  };

  const percentClickHandler = () => {
    
    let num = calc.num ? parseFloat(removeSpaces(calc.num)) : 0;
    let res = calc.res ? parseFloat(removeSpaces(calc.res)) : 0;
    setCalc({
      ...calc,
      num: (num /= Math.pow(100, 1)),
      res: (res /= Math.pow(100, 1)),
      sign: "",
    });
  };

  const resetClickHandler = () => {
    setCalculation('')
    setCalc({
      ...calc,
      sign: "",
      num: 0,
      res: 0,
    });
  };

  return (
    <>
        <Wrapper>
        <Screen /* calculation={calculation} */ value={calc.num ? calc.num : calc.res} />
        <ButtonBox>
            {btnValues.flat().map((btn, i) => {
            return (
                <Button
                key={i}
                className={btn === "=" ? "equals" : ""}
                value={btn}
                onClick={
                    btn === "C"
                    ? resetClickHandler
                    : btn === "+-"
                    ? invertClickHandler
                    : btn === "%"
                    ? percentClickHandler
                    : btn === "="
                    ? equalsClickHandler
                    : btn === "/" || btn === "X" || btn === "-" || btn === "+"
                    ? signClickHandler
                    : btn === "."
                    ? comaClickHandler
                    : numClickHandler
                }
                />
            );
            })}
        </ButtonBox>
        </Wrapper>
    </>
  );
}